import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import { createVuetify, type ThemeDefinition } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import type { TenantBranding } from "@tenant-theme";
import { buildTenantThemes } from "@/tenant/branding";

/**
 * Built AFTER the tenant resolves (unlike a module's static theme) — the
 * shell is the thing that publishes tenant colours, so it can't wait on
 * `@tenant-theme`'s `readTenant()` the way a hosted module does.
 */
export function createShellVuetify(branding: TenantBranding | null) {
  const { light, dark } = buildTenantThemes(branding);
  const defaultTheme = branding?.defaultTheme === "light" ? "light" : "dark";

  return createVuetify({
    icons: { defaultSet: "mdi", aliases, sets: { mdi } },
    display: { mobileBreakpoint: 768 },
    theme: {
      defaultTheme,
      themes: {
        light: light as ThemeDefinition,
        dark: dark as ThemeDefinition,
      },
    },
    defaults: {
      global: { ripple: true },
      VTextField: { variant: "outlined", density: "compact", hideDetails: "auto" },
      VBtn: { rounded: "lg" },
    },
  });
}
